import gql from 'graphql-tag';

export default gql`
  mutation CreateLabelPacels($orderIdList: [ID]) {
    createLabelPacels(orderIdList: $orderIdList) {
      linkDownLoads
    }
  }
`;
